import angular from 'angular';
import template from './template.html';
import './item';
import './style.scss';

export class CandidatesListLoading {
    $onChanges() {
        this.loadingItems = [...new Array(this.count || 5)].map((item, index) => index);
    }
}

export const CandidatesListLoadingConfiguration = {
    template,
    bindings: {
        count: '<',
    },
    controller: CandidatesListLoading,
    controllerAs: 'candidatesListLoadingCtrl',
};

angular.module('TALENYA-FE').component('candidatesListLoading', CandidatesListLoadingConfiguration);
